"use strict";
exports.__esModule = true;
exports.getActualDestinationRegion = exports.spectrumEventValidRegion = void 0;
var common_client_header_1 = require("@snapchat/ts-protos/spectrum/streaming/schema/client/common_client_header");
var spectrumUtils_1 = require("./util/spectrumUtils");
function spectrumEventValidRegion(event, region, allowlisted_events) {
    if (allowlisted_events === void 0) { allowlisted_events = REGIONALIZATION_ALLOWLISTED_EVENTS; }
    return region === common_client_header_1.Region.REGION_UNSET || allowlisted_events.has((0, spectrumUtils_1.getSpectrumEventName)(event));
}
exports.spectrumEventValidRegion = spectrumEventValidRegion;
function getActualDestinationRegion(region) {
    if (region === common_client_header_1.Region.REGION_UNSET) {
        return DEFAULT_DESTINATION_REGION;
    }
    return region;
}
exports.getActualDestinationRegion = getActualDestinationRegion;
var REGIONALIZATION_ALLOWLISTED_EVENTS = new Set(["adTrackEvent", "adTrackEventShadow"]);
var DEFAULT_DESTINATION_REGION = common_client_header_1.Region.REGION_US_CENTRAL_1;
//# sourceMappingURL=region.js.map